import * as React from 'react';

function SvgClose(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" ref={svgRef} {...props}>
      <path
        d="M14.364 12.911L9.454 8l4.91-4.91-1.453-1.454L8 6.546l-4.911-4.91-1.453 1.453L6.546 8l-4.944 4.944 1.454 1.454L8 9.454l4.911 4.91z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgClose);
export default ForwardRef;
